import React from 'react'
import { useSelector } from 'react-redux'

import ListItemsTotals from '../../../../features/components/ListItemsTotals'
import ListItemsTable from '../../../../features/components/ListItemsTable'

import useGetAdDropdownOptions from '../hooks/useGetAdDropdownOptions'

import { getSelectedPlatform } from '../../../../helpers/handlePlatformSelection'

import {
  adsErrorSelector,
  adsIsLoadingSelector,
  adsSelector,
  adsWasLoadedSelector,
  adUpdateIsLoadingSelector,
  adUpdateIdSelector,
  adsTotalsSelector
} from '../../../../modules/selectors/ads'
import { selectedAdAccountsSelector } from '../../../../modules/selectors/adAccounts'

const AdsTable = () => {
  const selectedPlatform = getSelectedPlatform()

  const adsList = useSelector(adsSelector)
  const adUpdateId = useSelector(adUpdateIdSelector)
  const adUpdateIsLoading = useSelector(adUpdateIsLoadingSelector)
  const adsTotals = useSelector(adsTotalsSelector)

  const { [selectedPlatform]: selectedAdAccount = {} } = useSelector(selectedAdAccountsSelector)

  const { currency_symbol: currencySymbol } = selectedAdAccount

  const getAdActionDropdownOptions = useGetAdDropdownOptions(selectedPlatform, selectedAdAccount.id)

  return (
    <ListItemsTable
      items={adsList}
      isLoadingSelector={adsIsLoadingSelector}
      errorSelector={adsErrorSelector}
      wasLoadedSelector={adsWasLoadedSelector}
      platform={selectedPlatform}
      currencySymbol={currencySymbol}
      getActionsDropdownOptions={getAdActionDropdownOptions}
      itemUpdatingId={adUpdateIsLoading ? adUpdateId : ''}
      showGoal={false}
    >
      {!!adsTotals && adsList.length > 1 && (
        <ListItemsTotals
          items={adsList}
          data={adsTotals}
          platform={selectedPlatform}
          currencySymbol={currencySymbol}
          hideDropdownColumn={!getAdActionDropdownOptions().length}
        />
      )}
    </ListItemsTable>
  )
}

export default AdsTable
